// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"c71c000b","584":"15a136cf"}[chunkId] + ".chunk.css";
};